const TTL_MS = 5 * 60 * 1000;
const store = new Map();

const keyFor = (kind, params) => `${kind}|${params?.client_id ?? ''}|${params?.period ?? ''}`;

export function peek(kind, params) {
  const hit = store.get(keyFor(kind, params));
  if (!hit) return null;
  if (Date.now() - hit.ts > TTL_MS) {
    store.delete(keyFor(kind, params));
    return null;
  }
  return hit.data;
}

export function put(kind, params, data) {
  store.set(keyFor(kind, params), { ts: Date.now(), data });
}

export function bust(params) {
  const clientId = String(params?.client_id ?? '');
  const period = String(params?.period ?? '');
  for (const key of Array.from(store.keys())) {
    const parts = key.split('|');
    if (parts[1] === clientId && parts[2] === period) {
      store.delete(key);
    }
  }
}

export function peekBudgetCenter(params) {
  return peek('bc', params);
}

export function peekScopeSpend(params) {
  return peek('scope', params);
}
